/**
 * @generated SignedSource<<a300c1c4fc1be24056a30d582a5ab850>>
 * @relayHash f70c9aa0babc43946b2c568d0a9868ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1195bf03ccc474c75832db70dfc053eec403b0c30d40f437cab380ae071ea7c5

import type { ConcreteRequest } from 'relay-runtime';
export type ContentDeleteActionType = "DELETE_DRAFT" | "DELETE_DRAFT_IF_BLANK" | "MOVE_TO_TRASH" | "PURGE_FROM_TRASH" | "%future added value";
export type useHandleDeleteOnboardingBlankPageMutation$variables = {
  action: ContentDeleteActionType;
  contentId: string;
};
export type useHandleDeleteOnboardingBlankPageMutation$data = {
  readonly deleteContent: {
    readonly contentId: string;
    readonly wasDeleted: boolean;
  } | null;
};
export type useHandleDeleteOnboardingBlankPageMutation = {
  response: useHandleDeleteOnboardingBlankPageMutation$data;
  variables: useHandleDeleteOnboardingBlankPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "action",
        "variableName": "action"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "DeleteContentResponsePayload",
    "kind": "LinkedField",
    "name": "deleteContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "wasDeleted"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useHandleDeleteOnboardingBlankPageMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useHandleDeleteOnboardingBlankPageMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f70c9aa0babc43946b2c568d0a9868ee",
    "id": "1195bf03ccc474c75832db70dfc053eec403b0c30d40f437cab380ae071ea7c5",
    "metadata": {},
    "name": "useHandleDeleteOnboardingBlankPageMutation",
    "operationKind": "mutation",
    "text": "mutation useHandleDeleteOnboardingBlankPageMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId,wasDeleted}}"
  }
};
})();

(node as any).hash = "2499f4dc8d89b567f1c3b7e615bfe79e";

export default node;
